import React from 'react';
import { Mail, Phone, MapPin, Users } from 'lucide-react';

const contacts = [
  {
    region: 'United States',
    contact: 'Paolo Enrile',
    role: 'Head of Marketing',
    phone: '+1 510-557-5204',
    email: 'pinoaisales@gmail.com',
    address: 'San Leandro, California USA',
    avatar: '👨‍💼'
  },
  {
    region: 'Philippines',
    contact: 'Jasper Roque',
    role: 'CEO & Developer',
    phone: '+63 915-4288-185',
    email: 'pinoaisales@gmail.com',
    address: 'San Leonardo, Nueva Ecija, Philippines 3102',
    avatar: '👨‍💻'
  }
];

export default function RegionalContacts() {
  return (
    <div className="space-y-6">
      {contacts.map((contact) => (
        <div
          key={contact.region}
          className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow"
        >
          <div className="flex items-center mb-6">
            <span className="text-4xl mr-4" role="img" aria-label={contact.role}>
              {contact.avatar}
            </span>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                {contact.contact}
              </h3>
              <p className="text-purple-600 dark:text-purple-400">{contact.role}</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">{contact.region}</p>
            </div>
          </div>

          <div className="space-y-4">
            <a
              href={`tel:${contact.phone}`}
              className="flex items-center text-gray-600 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400"
            >
              <Phone className="w-5 h-5 mr-3 text-purple-600" />
              <span>{contact.phone}</span>
            </a>
            
            <a
              href={`mailto:${contact.email}`}
              className="flex items-center text-gray-600 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400"
            >
              <Mail className="w-5 h-5 mr-3 text-purple-600" />
              <span>{contact.email}</span>
            </a>

            <div className="flex items-center text-gray-600 dark:text-gray-300">
              <MapPin className="w-5 h-5 mr-3 text-purple-600" />
              <span>{contact.address}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}